// AdminHeader.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./api";

export default function AdminHeader() {
  const navigate = useNavigate();
  
  const loginUser = localStorage.getItem("loginUser") || "Admin";
  const userEmail = localStorage.getItem("userEmail") || "User";
  const userMobile = localStorage.getItem("user_mobileno");
  const handleLogout = async () => {
    try {
      // call API to clear server session (if exists)
      await fetch(`${API_BASE_URL}/api/admin/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (e) {
      console.warn("server logout failed", e);
    }
    // clear client state
    localStorage.removeItem("user_mobileno");
    localStorage.removeItem("userEmail");
    navigate("/");
//navigate("/admin-login"); for login page
  };

  return (
    <header style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      background: "#4287f5",
      color: "white",
      padding: "12px 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 1000
    }}>
      <div>Logged in as: <strong>{userEmail}</strong></div>

      <div>
        <button onClick={() => navigate("/admin-dashboard")} style={{ marginRight: 8 }}>Dashboard</button>
        <button onClick={() => navigate("/admin-dashboard")} style={{ marginRight: 8 }}>New Entry</button>
        <button onClick={handleLogout} style={{ background: "red", color: "white", border: "none", padding: "6px 10px" }}>Logout</button>
      </div>
    </header>
  );
}

